export const faqs = [
  {
    question: "What is the minimum age for Playgroup?",
    answer: "The minimum age for Playgroup admission is 1.5 years (18 months) at the time of entry."
  },
  {
    question: "Can parents visit the school before admission?",
    answer: "Absolutely! We encourage parents to visit our campus. You can book an in-person school tour via our Contact page or call us at +91 82491 56053 to schedule a visit during school hours."
  },
  {
    question: "What documents are required for admission?",
    answer: "You will need: the child's birth certificate, recent passport-size photographs, Aadhaar copy of parent/guardian, address proof, previous school records (if applicable), and medical/allergy information (if required)."
  },
  {
    question: "Is school transportation available?",
    answer: "Yes, we provide safe and reliable transportation support with trained drivers and helpers. Transport is subject to route availability in Bhubaneswar; please check with the office for routes."
  },
  {
    question: "How can I learn about the latest fees?",
    answer: "Please contact our admission office or submit the Enquiry form. Since transport fees and special offers vary, our counselor will provide the complete detailed fee structure during your counseling session."
  },
  {
    question: "How will parents receive progress updates?",
    answer: "Parents receive regular updates through progress reports, parent-teacher meetings (PTMs), child-development discussions, and direct updates via WhatsApp or school announcements."
  },
  {
    question: "Can I apply online?",
    answer: "Yes, you can initiate the process by filling out our Online Admission Enquiry Form. Our team will contact you to schedule the counseling visit and complete the enrollment."
  },
  {
    question: "How do I select the correct program for my child?",
    answer: "Our programs are designed according to age groups (Playgroup: 1.5-2.5 yrs, Nursery: 2.5-3.5 yrs, LKG: 3.5-4.5 yrs, UKG: 4.5-5.5 yrs). If you are unsure, choose 'Not Sure - Need Guidance' on the form, and our counselor will assist you."
  }
];
